import { FC, useState } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { getProgramById } from "API/programApi";
import useErrorToast from "hook/error-toast";
import { Spinner } from "@chakra-ui/spinner";
import { Text } from "@chakra-ui/layout";
import { Select } from "@chakra-ui/select";

import { useAppDispatch } from "app/hook";
import { setProgram } from "app/features/program/programSlice";
import Chapters from "./Chapters/Chapters";
interface ProgramSubjectSelectProps {}

const ProgramSubjectSelect: FC<ProgramSubjectSelectProps> = () => {
  const [subjectId, setSubjectId] = useState("");
  const { id } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();
  const {
    data: program,
    isLoading,
    error,
  } = useQuery<IProgram>(
    ["program", id, subjectId],
    () => getProgramById(id, subjectId),
    { onSuccess: (data) => dispatch(setProgram({ subjectId, program: data })) }
  );

  useErrorToast(error);

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <Text>Program Name: {program?.name}</Text>
          <Select
            mt="8"
            placeholder="Select Subject"
            rounded="md"
            textTransform="capitalize"
            value={subjectId}
            onChange={(e) => {
              setSubjectId(e.target.value);
            }}
          >
            {program?.subjects?.map((e: ISubject) => (
              <option key={e?.name} value={e._id}>
                {e.name}
              </option>
            ))}
          </Select>

          <Chapters />
        </>
      )}
    </>
  );
};
export default ProgramSubjectSelect;
